import React from "react";
import ReactDOM from "react-dom";

// Theme Akkhor
import './assets/css/normalize.css'
import './assets/css/main.css'
import './assets/css/bootstrap.min.css'
import './assets/css/all.min.css'
import './assets/fonts/flaticon.css'
import './assets/css/select2.min.css'
import './assets/css/fullcalendar.min.css'
import './assets/css/animate.min.css'
import './assets/style.css'
import 'bootstrap/dist/css/bootstrap.css';
import './assets/css/datepicker.min.css';

import './assets/ebook.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import './assets/css/style.css';
// End Theme

import "./index.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./assets/css/bangtin.css";

import App from "./App";

// ✅ Đổi từ serviceWorker sang serviceWorkerRegistration
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import mockAxios from "./mocks";
import { Provider } from "react-redux";
import store, { persistor } from "./redux/store";
import { actions as authActions } from "./redux/authRedux";
import { URL_LIST_ALL } from "./configs/api";
import { PersistGate } from "redux-persist/integration/react";

var axios = require("axios");
const { REACT_APP_USE_MOCK_DATA } = process.env;
if (REACT_APP_USE_MOCK_DATA === "true") mockAxios(axios);

// ---------------------------------------------------------------------------
// Phiên hết hạn -> thử làm mới token, chỉ đăng xuất khi thực sự không cứu được
// (thêm 03/11/2026, sửa lại 04/11/2026)
//
// Backend KHÔNG phân biệt được hai tình huống rất khác nhau — cả hai đều trả
// {status:'error', message:'Vui lòng đăng nhập', code:'login'} kèm HTTP 200:
//   (1) access token HẾT HẠN  -> cứu được bằng refresh token, người dùng không
//       cần biết gì cả. Đây là chuyện BÌNH THƯỜNG, mỗi giờ một lần.
//   (2) token sai/giả mạo     -> phải đăng nhập lại.
// (Đã kiểm chứng 04/11/2026 bằng token hết hạn có chữ ký hợp lệ: phản hồi
//  giống hệt token rác.)
//
// Vì vậy KHÔNG được đăng xuất chỉ vì thấy 'Vui lòng đăng nhập'. Bản 03/11 làm
// đúng như thế nên từ khi token rút còn 1 giờ, cứ mỗi giờ là toàn bộ người dùng
// bị đá ra trang login (03/11: 259 lượt đăng nhập/132 người, chỉ 6 lượt refresh
// thành công — trong khi ngày thường là 20-45 lượt refresh).
//
// Cách xử lý: gặp lỗi phiên thì GỌI /refresh một lần. Refresh được thì phát lại
// đúng request vừa hỏng, người dùng không thấy gián đoạn. Chỉ khi chính /refresh
// bị từ chối mới đăng xuất — lúc đó mới chắc chắn là không cứu được.
const MA_LOI_PHIEN = ["login", "tokeninvalid", "refreshtokenexpired"];
const LOI_PHIEN_THEO_CHU = [
  "vui lòng đăng nhập",
  "token không đúng hoặc hết hạn",
  "thiếu token",
  "tài khoản không còn tồn tại",
  "tài khoản đã ngừng hoạt động",
];

function laLoiPhien(dl) {
  if (!dl || dl.status !== "error") return false;
  if (dl.code && MA_LOI_PHIEN.includes(dl.code)) return true;
  if (typeof dl.message !== "string") return false;
  const tb = dl.message.toLowerCase();
  return LOI_PHIEN_THEO_CHU.some((m) => tb.includes(m));
}

let dangChuyenTrang = false;

function veTrangDangNhap() {
  // Chỉ chạy MỘT lần: một màn hình thường gọi nhiều API song song, nếu không
  // chặn thì mỗi lời gọi lại kích hoạt một lần chuyển trang.
  if (dangChuyenTrang) return;
  dangChuyenTrang = true;

  try {
    store.dispatch(authActions.logout());
  } catch (e) {
    // Dù dọn redux thất bại vẫn phải đưa người dùng ra trang đăng nhập.
    console.log("Không dọn được phiên:", e);
  }

  // Dùng replace để nút Back không quay lại trang đang lỗi.
  if (!window.location.pathname.startsWith("/auth")) {
    window.location.replace("/auth/login");
  }
}

// Gộp mọi request lỗi cùng lúc vào CHUNG một lần gọi /refresh: một màn hình có
// thể bắn 5-10 API song song, tất cả cùng hết hạn, không thể gọi refresh 10 lần.
let dangLamMoi = null;

function layTokenMoi() {
  if (dangLamMoi) return dangLamMoi;

  dangLamMoi = new Promise((resolve) => {
    let refreshToken = null;
    try {
      refreshToken = store.getState().auth.user.refresh_token;
    } catch (e) {
      refreshToken = null;
    }
    if (!refreshToken) return resolve(null);

    // axios "trần" để không rơi lại vào chính interceptor này.
    axios
      .get(URL_LIST_ALL + "refresh", {
        headers: { Authorization: "Bearer " + refreshToken },
      })
      .then((res) => {
        if (res.data && res.data.status === "success") {
          const nguoiDung = res.data;
          nguoiDung.config = {
            headers: { Authorization: "Bearer " + res.data.access_token },
          };
          axios.defaults.headers.common["Authorization"] =
            "Bearer " + res.data.access_token;
          store.dispatch(authActions.login(nguoiDung));
          resolve(res.data.access_token);
        } else {
          resolve(null);
        }
      })
      .catch(() => resolve(null));
  }).finally(() => {
    dangLamMoi = null;
  });

  return dangLamMoi;
}

axios.interceptors.response.use(
  (response) => {
    if (!laLoiPhien(response && response.data)) return response;

    const cauHinh = response.config || {};
    // Lỗi phiên từ chính /refresh -> hết đường cứu.
    if (typeof cauHinh.url === "string" && cauHinh.url.indexOf("refresh") > -1) {
      veTrangDangNhap();
      return response;
    }
    // Đã thử làm mới một lần rồi mà vẫn lỗi -> đăng xuất, tránh lặp vô hạn.
    if (cauHinh.__daThuLamMoi) {
      veTrangDangNhap();
      return response;
    }

    return layTokenMoi().then((tokenMoi) => {
      if (!tokenMoi) {
        veTrangDangNhap();
        return response;
      }
      // Phát lại đúng request vừa hỏng với token mới.
      cauHinh.__daThuLamMoi = true;
      cauHinh.headers = { ...cauHinh.headers, Authorization: "Bearer " + tokenMoi };
      return axios(cauHinh);
    });
  },
  (error) => {
    // 401/403 từ máy chủ cũng là phiên không còn hợp lệ.
    const ma = error && error.response && error.response.status;
    if (ma === 401 || ma === 403) veTrangDangNhap();
    return Promise.reject(error);
  }
);
// ---------------------------------------------------------------------------

window.onerror = function (message, source, lineno, colno, error) {
  alert(`Lỗi: ${message} tại ${source}:${lineno}:${colno}`);
  console.log("Chi tiết lỗi:", error);
};

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={<div>Loading...</div>}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// ✅ ĐĂNG KÝ SERVICE WORKER CHO PWA
serviceWorkerRegistration.register();
